<template>
    <div class="stages-editor">
        <div>
            <template v-for="(stage,index) in store.stages">
                <stage-row :index="index"></stage-row>
            </template>
        </div>
        <b-btn class="mt-3" size="sm" variant="light" @click.prevent="addStage"><i class="la la-plus"></i>Add stage
        </b-btn>
    </div>
</template>

<script>


import store, {init} from "./store";
import StageRow from "./StageRow.vue";

export default {
    name: 'StagesEditor',
    components: {StageRow},
    props: [
        'name',
        'value',
        'operators',
        'discountActivations',
        'discountActivationTemplates'
    ],
    data() {
        return {}
    },
    computed: {
        store() {
            return store;
        }
    },
    watch: {
        'store.stages': {
            deep: true,
            handler(value) {
                this.$emit('change', value)
            }
        }
    }
    ,
    created() {
        init({
            stages: this.value,
            discountActivations: this.discountActivations,
            discountActivationTemplates: this.discountActivationTemplates,
            operators: this.operators
        })
    },
    methods: {
        addStage() {
            this.store.stages.push({op: null, label: '', value: []})
        }
    },
}
</script>

<style lang="scss">
.stages-editor {
    .json-editor .object-view .value__input {
        border-color: #eeeeee;
    }
}

</style>
